import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IVehicleResponse, IVehicleState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowVehicle = createAsyncThunk(
  'listVehicles/fetchShowVehicle',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.getVehicle(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IVehicleState = {
  isLoading: false,
  response: null,
  error: null
}

const showVehicleSlice = createSlice({
  name: 'vehicles/show',
  initialState,
  reducers: {
    resetShowVehicle: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowVehicle.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowVehicle.fulfilled, (state, action: PayloadAction<IVehicleResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowVehicle.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showVehicleSlice.reducer
export const { resetShowVehicle } = showVehicleSlice.actions
